import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const noAuthRpcClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});